export const TYPE_MOVIES = 1;
export const TYPE_CHANNEL = 2;
export const TYPE_TV_SHOW = 3;
export const TYPE_SPORT = 4;
export const TYPE_OTHER = 5;
export const GENRE_FORM = 1;
export const GENRE_KIND = 2;


// WEBPACK FOOTER //
// ./src/constants/TypesAndGenreCategory.js